import { memo } from "react";

function LayoutAdd({ size = 18 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor">
      <rect opacity=".25" x="6" y="6" width="12" height="12" />
      <path d="M4,20H20V4H4ZM6,6H18V18H6Z" />
    </svg>
  );
}
export default memo(LayoutAdd);
